import { useUser } from '@clerk/clerk-react';

// AuthWatcher kept as a placeholder for auth-related side effects.
// Intentionally does NOT perform any navigation to avoid automatic
// redirects after sign-in. If you need to run post-login logic later,
// add it here but avoid calling navigate() without explicit user action.
export default function AuthWatcher() {
  // We still read auth state so this component will re-render when the
  // user signs in/out. Useful for future hooks (analytics, telemetry).
  const { isSignedIn } = useUser();

  // No redirects performed.
  return null;
}
